const REGISTER_USER_SUCCESS = "REGISTER_SUCCESS";
const REGISTER_USER_FAIL = "REGISTER_SUCCESS";
const LOGIN_USER_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_USER_FAIL = "LOGIN_FAIL";
const AUTH_LOADING_ON = "AUTH_LOADING_ON";
const AUTH_LOADING_OFF = "AUTH_LOADING_OFF";
const PROFILE_UPDATE = "PROFILE_UPDATE";
const PROFILE_UPDATE_IMAGE = "PROFILE_UPDATE_IMAGE";
const OTP_REQUEST_SENT = "SENT_OTP_REQUEST";
const OTP_REQUEST_VERIFIED = "OTP_REQUEST_VERIFIED";
const GENERATE_PASSWORD_SUCCESS = "GENERATE_PASSWORD_SUCCESS";

export {
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAIL,
  LOGIN_USER_FAIL,
  LOGIN_USER_SUCCESS,
  AUTH_LOADING_OFF,
  AUTH_LOADING_ON,
  PROFILE_UPDATE,
  PROFILE_UPDATE_IMAGE,
  OTP_REQUEST_SENT,
  OTP_REQUEST_VERIFIED,
  GENERATE_PASSWORD_SUCCESS,
};
